import { render, staticRenderFns } from "./devplatform.vue?vue&type=template&id=99ceb958&scoped=true&"
import script from "./devplatform.vue?vue&type=script&lang=js&"
export * from "./devplatform.vue?vue&type=script&lang=js&"
import style0 from "./devplatform.vue?vue&type=style&index=0&id=99ceb958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ceb958",
  null
  
)

export default component.exports